import { IEvent, ICreateNewEvent, IEditEvent, IDeleteEvent, IAiTask, IEditEventVisibility } from '@app-types/websocket/event.types';
import { IAiScheduleTurn } from '@app-types/websocket/aiSchedule.types';
import WebSocketClient from '@clients/web-socket.client';

const socket = WebSocketClient.getInstance();

export function createEvent(data: ICreateNewEvent) {

  socket.sendJSON({
    newEvent: data,
  });
}

export function editEvent(data: IEditEvent) {

  socket.sendJSON({
    editEvent: data,
  });
}

export function deleteEvent(data: IDeleteEvent) {

  socket.sendJSON({
    deleteEvent: data,
  });
}

export function seenEvent(data: number) {

  socket.sendJSON({
    seenEvent: data,
  });
}

export function completedEvent(data: number) {

  socket.sendJSON({
    completedEvent: data,
  });
}

export function analyzeImage(data: number) {

  socket.sendJSON({
    analyzeEventImage: data,
  });
}

export function analyzeReceiptImage(data: number) {

  socket.sendJSON({
    analyzeReceiptImage: data,
  });
}

export function analyzeImageDismiss(data: number) {

  socket.sendJSON({
    dismissAnalyzedImage: data,
  });
}
export function aiTask(data: IAiTask) {

  socket.sendJSON({
    aiTask: data,
  });
}

export function dismissAiTask(data: number) {

  socket.sendJSON({
    dismissAiTask: data,
  });
}

export function aiScheduleTurn(data: IAiScheduleTurn) {

  socket.sendJSON({
    aiScheduleTurn: data,
  });
}


export function addViewerToEvent(data: IEditEventVisibility) {

  socket.sendJSON({
    eventViewerUpdate: data,
  });

}



// WEBPACK FOOTER //
// ./src/services/events/event.websocket.ts